import React from 'react';
import CountUp from 'react-countup';
import SkillBar from 'react-skillbars';

const skills = [
    { type: 'Architecher', level: 90 },
    { type: 'Construction', level: 85 },
    { type: 'Building', level: 80 },
    { type: 'Interior', level: 90 },
    { type: 'Commercial', level: 60 }
];
const colors = {
    bar: "#F5BF23",
    title: {
      text: "#fff",
      background: "#F5BF23"
    }
};

const Counter = () => {
    return(
    <>
    {/*Counter Section*/}
      <section className="counter-section section-padding-all">
        <div className="com-counter default-container">
          <div className="row clearfix">
            <div className="con-title-column col-lg-12 col-md-12 col-sm-12">
              {/*Sec Title*/}
              <div className="sec-con-title text-center centered mx-auto">
                <div className="con-title-text con-title-border-l">15 years experience in construction</div>
                <h2>We Have</h2>
                <div className="text">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</div>
              </div>
            </div>
          </div>
          <div className="row clearfix">
            {/*Column*/}
            <div className="column counter-column col-md-6 col-sm-6 col-xs-12">
              <div className="row clearfix">
                <div className="column counter-column col-md-6 col-sm-6 col-xs-12">
                  <div className="inner">
                    <div className="content">
                      <div className="count-outer count-box">
                        <span className="count-text"><CountUp start={0} end={775}></CountUp></span>+
                      </div>
                      <h4 className="counter-title">happy customers</h4>
                    </div>
                  </div>
                </div>
                {/*Column*/}
                <div className="column counter-column col-md-6 col-sm-6 col-xs-12">
                  <div className="inner">
                    <div className="content">
                      <div className="count-outer count-box alternate">
                        <span className="count-text"><CountUp start={0} end={279}></CountUp></span>+
                      </div>
                      <h4 className="counter-title">Project complete</h4>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row clearfix">
                <div className="column counter-column col-md-6 col-sm-6 col-xs-12">
                  <div className="inner">
                    <div className="content">
                      <div className="count-outer count-box alternate">
                        <span className="count-text"><CountUp start={0} end={675}></CountUp></span>+
                      </div>
                      <h4 className="counter-title">World Wide Branch</h4>
                    </div>
                  </div>
                </div>
                {/*Column*/}
                <div className="column counter-column col-md-6 col-sm-6 col-xs-12">
                  <div className="inner">
                    <div className="content">
                      <div className="count-outer count-box">
                        <span className="count-text"><CountUp start={0} end={471}></CountUp></span>+
                      </div>
                      <h4 className="counter-title">Digital Instrument</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="column counter-column col-md-6 col-sm-6 col-xs-12">
              <div className="row clearfix m-t60">
                <div className="column counter-column col-md-12 col-sm-12 col-xs-12">
                    <SkillBar skills={skills} colors={colors} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*End Counter Section*/}
    </>
    )
}

export default Counter;